module.exports = __webpack_public_path__ + "static/media/arrow-down.bf9da378.svg";